import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { GlobalNav as FFFGlobalNav } from '@nexus/fff-global-nav';

import env from 'utils/env';
import withViewSize from 'HOC/withViewSize/withViewSize';
import { VIEW_SIZE } from 'utils/device';
import { receiveUpdateCart } from 'services/actions/cartActions';
import styles from './GlobalNav.module.css';
import MobileSearchBar from './MobileSearchBar';

const GlobalNav = ({
  hideCart,
  stickyCartPage,
  showMobileSearchBar,
  viewSize,
}) => (
  <div className={styles.container} id="global-nav" data-testid="global-nav">
    <FFFGlobalNav
      hideCart={hideCart}
      env={env.appEnv}
      stickyCartPage={stickyCartPage}
    />
    {(viewSize === VIEW_SIZE.small || viewSize === VIEW_SIZE.medium) &&
      showMobileSearchBar && <MobileSearchBar />}
  </div>
);

GlobalNav.propTypes = {
  hideCart: PropTypes.bool,
  stickyCartPage: PropTypes.bool,
  showMobileSearchBar: PropTypes.bool,
  viewSize: PropTypes.string.isRequired,
};

GlobalNav.defaultProps = {
  hideCart: false,
  stickyCartPage: false,
  showMobileSearchBar: false,
};

const mapStateToProps = (state) => ({
  viewSize: state.viewState.viewSize,
});

const mapDispatchToProps = {
  receiveUpdateCart,
};

export default compose(
  withViewSize,
  connect(mapStateToProps, mapDispatchToProps)
)(GlobalNav);
